import React from "react";
import TextInfo from "@gc-npm/components.text";
import Card from "./card";

const taggingInfo = {
  componentVariation: "",
  componentContent: "",
  eventType: "click",
};

const RoamingCard = (props) => {
  const { country, type } = props;
  const characKeys = Object.keys(props).filter((key) =>
    /^Charac-\d+$/.test(key)
  );
  const characValues = characKeys
    .map((key) => props[key])
    .filter((item) => {
      return item.typeMovil.indexOf(type) > -1;
    });

  return (
    <div
      className="roaming-cards-container container"
      data-cy="fibre-pros-section"
    >
      <div className="interest--title">
        <TextInfo
          {...props["Text-1"]}
          text={`Estas son las tarifas para ${country}`}
          cyData="RoamingCard Title"
        />
      </div>

      <div className="roaming-card-content">
        <div className="card-container-grid">
          {characValues &&
            Array.isArray(characValues) &&
            characValues.length &&
            characValues.map((card, index) => (
              <Card
                {...card}
                key={`roaming-card-${index}`}
                index={index}
                taggingInfo={taggingInfo}
              />
            ))}
        </div>
      </div>
      <style jsx>
        {`
          .roaming-cards-container {
            margin-top: 0;
            margin-bottom: 0;
            padding: 1rem;
            :global(.interest--title) {
              margin-top: 0.75rem;
              margin-bottom: 1rem;
            }
            .roaming-card-content {
              margin-top: 1rem;
              .card-container-grid {
                display: grid;
                gap: 24px;
                grid-template-columns: repeat(auto-fill, minmax(360px, 1fr));

                @media screen and (max-width: 768px) {
                  display: inline-flex;
                  flex-direction: row;
                  overflow-x: auto;
                  overflow-y: hidden;
                  gap: 12px;
                  width: 100%;
                }
                &::-webkit-scrollbar {
                  display: none;
                }
              }
            }
            @media screen and (min-width: 768px) {
              margin-top: 1.5rem;
              margin-bottom: 1.25rem;
            }
          }
        `}
      </style>
    </div>
  );
};

export default RoamingCard;
